import {draftStore} from './draftStore';
export async function captureOptions(userId, businessId, type, load) {
  if (!userId) throw new Error('Sign in to access capture settings.');
  const key = `capture:${userId}:${businessId}:${type}`;
  if (!navigator.onLine) return (await draftStore.getMeta(key)) || [];
  const value = await load();
  // Metadata caching must not turn a successful read into a failed screen.
  try { await draftStore.setMeta(key, value); } catch { /* Queue writes report storage errors separately. */ }
  return value;
}
